













































































































import { Component } from 'vue-mixin-decorator';

import BaseView from '@/views/BaseView.vue';
import ExamFooter from '@/components/ExamFooter.vue';
import ExamGuide from '@/components/ExamGuide.vue';
import ExamNav from '@/components/ExamNav.vue';

import { REGISTER_USER_INFO, EXAMINEE_ITEMS } from '@/classification/SessionStorageKey';
import * as DesignCode from '@/classification/DesignCode';

import * as StringUtil from '@/common/StringUtil';

import RepositoryFactory from '@/repository/RepositoryFactory';

import Rank from '@/models/rank/Rank';
import DesignResource from '@/models/exam/DesignResource';

@Component(
  {
    components: {
      'e-footer': ExamFooter,
      'e-guide': ExamGuide,
      'e-nav': ExamNav,
    },
  },
)

export default class RegistComplete extends BaseView {
  private ExamRepository = RepositoryFactory.get().exam;

  private RankRepository = RepositoryFactory.get().rank;

  private examTitle = '';

  private acceptingRank: Rank[] = [];

  private resources = {
    ENTRY_ICON: new DesignResource(),
    ACCOUNT_ENTRY_BG: new DesignResource(),
    ACCOUNT_ENTRY_MAIN_COLOR: new DesignResource(),
    ACCOUNT_ENTRY_SUB_TITLE_COLOR: new DesignResource(),
  };

  private created() {
    // SessionStorageの登録情報を削除
    sessionStorage.removeItem(REGISTER_USER_INFO);
    sessionStorage.removeItem(EXAMINEE_ITEMS);

    // 検定情報を取得する
    try {
      this.ExamRepository.getExam().then((response) => {
        if (response.status === 200) {
          this.examTitle = response.data.exam_title;

          // デザインリソース
          if (response.data.resources !== undefined) {
            response.data.resources.forEach((resource: any) => {
              const key = resource.display_place_key;
              if (key in this.resources) {
                const tmp = new DesignResource();
                tmp.displayPlaceKey = resource.display_place_key;
                tmp.displayText = StringUtil.isEmpty(resource.display_text) ? '' : resource.display_text;
                tmp.cssClassName = StringUtil.isEmpty(resource.css_class_name) ? '' : resource.css_class_name;
                tmp.resourceUri = StringUtil.isEmpty(resource.resource_uri) ? '' : resource.resource_uri;
                tmp.resourceFileName = StringUtil.isEmpty(resource.resource_file_name) ? '' : resource.resource_file_name;
                tmp.alternativeText = StringUtil.isEmpty(resource.alternative_text) ? '' : resource.alternative_text;
                // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
                // @ts-ignore
                this.resources[key] = tmp;
              }
            });
          }
        }
      }).catch(() => {
        // do nothing
      });
    } catch (e) {
      // do nothing
    }

    // 検定ランク情報を取得する
    try {
      this.RankRepository.getRanks().then((response) => {
        if (response.status === 200) {
          response.data.exam_ranks.forEach((rank: any) => {
            const rankInfo = new Rank();
            rankInfo.rankCode = StringUtil.encodeToBase64Url(rank.exam_rank_code);
            rankInfo.title = rank.exam_rank_title;
            rankInfo.paymentType = rank.exam_fee_type;
            if (rank.fees.length > 0) {
              rankInfo.fee = StringUtil.separateNumber(rank.fees[0].fee);
            } else {
              rankInfo.fee = '0';
            }

            // eslint-disable-next-line prefer-destructuring
            const resources = rank.resources;
            if (resources !== undefined && resources.length > 0) {
              resources.forEach((resource: any) => {
                if (resource.display_place_key === DesignCode.EXAM_RANK_ICON) {
                  rankInfo.thumbnail = resource.resource_uri;
                  rankInfo.alternativeText = resource.alternative_text;
                }
              });
            }

            // 開始中か受付中かを判定し、配列を振り分ける
            if (rank.is_accepting) {
              this.acceptingRank.push(rankInfo);
            }
          });
        }
      }).catch(() => {
        // do nothing
      });
    } catch (e) {
      // do nothing
    }
  }

  private mounted() {
    const CommonCss = document.createElement('link');
    CommonCss.rel = 'stylesheet';
    CommonCss.href = '/css/common.css';
    this.$el.appendChild(CommonCss);

    const AccountCommonCss = document.createElement('link');
    AccountCommonCss.rel = 'stylesheet';
    AccountCommonCss.href = '/account/css/common.css';
    this.$el.appendChild(AccountCommonCss);

    const CompleteCss = document.createElement('link');
    CompleteCss.rel = 'stylesheet';
    CompleteCss.href = '/account/css/complete.css';
    this.$el.appendChild(CompleteCss);

    this.getExamConfigCss().then((cssElement: HTMLLinkElement) => {
      this.$el.appendChild(cssElement);
    });

    const CommonJs = document.createElement('script');
    CommonJs.src = '/js/common.js';
    this.$el.appendChild(CommonJs);
  }

  /**
   * 検定詳細画面に遷移します。
   *
   * @param ランクコード（Base64エンコードされたコード）
   */
  private transitionExamDetail(rankCode: string) {
    this.$router.replace(`/kentei/detail?rank=${rankCode}`);
  }
}
